import { fetchMessageTypes } from 'modules/workflowNodeEditors/components/StartNodeEditor/resourceComponents/graphql';
import { useGraphql } from 'utils/hooks/useGraphql';
import { FilterListValueInput } from '../FilterListInput/FilterListValueInput';

type FilterListMembershipValueInputProps = {
  onChange: (value: string) => void;
  value: string;
  id: string;
  isDisabled?: boolean;
  hasError: boolean;
  placeholder?: string;
};

export const FilterMessageTypeInput = ({
  id,
  onChange,
  value,
  isDisabled = false,
  hasError = false,
  placeholder,
}: FilterListMembershipValueInputProps) => {
  const { data, isLoading } = useGraphql(fetchMessageTypes);
  const listType = 'message type';
  return (
    <FilterListValueInput
      id={id}
      lists={data?.messageTypes}
      listType={listType}
      placeholder={placeholder}
      isDisabled={isDisabled || isLoading}
      onChange={onChange}
      value={value}
      isLoading={isLoading}
      hasError={hasError}
    />
  );
};
